// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~css/colors.css'","_gray-light":"#eaeaea","thead":"TableHead_thead__EZ8H5"};